/** Shared test hosts that can be assigned to any business and taken over freely. */
export const TEST_SLOT_SUBDOMAINS = ['web', 'webtwo'];
/** First-level hosts reserved for platform services — not valid business website subdomains. */
export const RESERVED_WEBSITE_SUBDOMAINS = [
    'api',
    'admin',
    'customer',
    'widgets',
    'website',
    'accounting',
    'call-service-api',
    'call-service',
    'commercial',
    'gmail',
    'visualizer-api',
    'visualizer',
    'mcp',
    'messenger',
    'www',
];
const TEST_SLOT_SET = new Set(TEST_SLOT_SUBDOMAINS);
const RESERVED_SET = new Set(RESERVED_WEBSITE_SUBDOMAINS);
export function normalizeWebsiteSubdomain(subdomain) {
    return subdomain?.trim().toLowerCase() ?? '';
}
export function isTestSlotSubdomain(subdomain) {
    const value = normalizeWebsiteSubdomain(subdomain);
    return value.length > 0 && TEST_SLOT_SET.has(value);
}
export function isReservedWebsiteSubdomain(subdomain) {
    const value = normalizeWebsiteSubdomain(subdomain);
    if (!value || isTestSlotSubdomain(value))
        return false;
    return RESERVED_SET.has(value);
}
/** Strip protocol, path, query, port; lowercase hostname for website custom domains. */
export function parseWebsiteHostname(raw) {
    let host = decodeURIComponent(raw || '').trim().toLowerCase();
    if (!host)
        return '';
    host = host.replace(/\.$/, '');
    host = host.replace(/^https?:\/\//, '');
    host = host.split('/')[0] ?? '';
    host = host.split('?')[0] ?? '';
    host = host.split('#')[0] ?? '';
    host = host.split(':')[0] ?? '';
    return host;
}
export function normalizeOptionalWebsiteDomainField(value) {
    if (value === undefined)
        return undefined;
    if (value === null)
        return null;
    const trimmed = value.trim();
    return trimmed === '' ? null : trimmed;
}
export function isValidWebsiteCustomDomain(domain) {
    if (!domain || !domain.includes('.'))
        return false;
    return /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$/.test(domain);
}
//# sourceMappingURL=websiteHosting.js.map